import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/lib/supabase';
import type { ServiceLog } from '@/types';

export function useServiceLogs(itemId: string) {
  const [logs, setLogs] = useState<ServiceLog[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const { data } = await supabase
      .from('service_logs')
      .select('*')
      .eq('item_id', itemId)
      .order('done_date', { ascending: false });
    setLogs((data ?? []) as ServiceLog[]);
    setLoading(false);
  }, [itemId]);

  useEffect(() => { load(); }, [load]);

  return { logs, loading, reload: load };
}
